import { createFileRoute } from "@tanstack/react-router"
import { SurveySites } from "@/components/project/ProjectDataSheet/SurveySites"

export const Route = createFileRoute("/_private/projects/$id/data/sites/")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  return (
    <SurveySites
      onBack={() => navigate({ to: "/projects/$id/data", params: { id } })}
    />
  )
}
